import React, { useEffect, useState } from "react";
import Axios from "axios";
import Translate from "@src/components/translation/Translate";
import styled from "@emotion/styled";
import { theme } from "@src/components/nessie-web";

const {
  colors: { dt_taro40, dt_taro50, dt_white, dt_aqua50 },
} = theme;

const JobType = styled("h3")`
  color: ${dt_white};
  font-size: 24px;
  font-weight: 800;
  margin-top: 0px;
  margin-bottom: 20px;
  display: block;
  text-align: left;
`;

const JobContainer = styled("h3")`
  width: 100%;
  margin; auto;
`;

const JobWrapper = styled("div")`
  width: 100%;
  margin-top: 40px;
  padding-top: 40px;
  border-top: 3px solid ${dt_taro50};

  &:last-of-type {
    border-bottom: 3px solid ${dt_taro50};
  }
`;

const JobBox = styled("a")`
  min-height: 1px;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 30px;
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const JobTitle = styled("span")`
  color: ${dt_aqua50};
  display: block;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
`;

const JobLocation = styled("span")`
  color: ${dt_taro40};
  display: block;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
`;

interface JobOpenings {
  marketing?: any[];
  engineering?: any[];
  design?: any[];
  product?: any[];
  people?: any[];
  customerSuccess?: any[];
  dataScience?: any[];
  otherPositions?: any[];
}

function CurrentOpeningsSection() {
  const [jobs, setJobs] = useState<JobOpenings>({});
  useEffect(() => {
    Axios.get("https://api.greenhouse.io/v1/boards/classdojo/jobs?content=true", { withCredentials: false })
      .then(function (response) {
        const data = response.data;
        const jobsObject: JobOpenings = {};
        const marketing = [];
        const engineering = [];
        const design = [];
        const product = [];
        const people = [];
        const customerSuccess = [];
        const dataScience = [];
        const otherPositions = [];
        for (let i = 0; i < data.jobs.length; i++) {
          if (data.jobs[i].departments[0]) {
            if (data.jobs[i].departments[0].name == "Engineering") {
              engineering.push(data.jobs[i]);
            } else if (data.jobs[i].departments[0].name == "Marketing and Communications") {
              marketing.push(data.jobs[i]);
            } else if (data.jobs[i].departments[0].name == "Product") {
              product.push(data.jobs[i]);
            } else if (data.jobs[i].departments[0].name == "People") {
              people.push(data.jobs[i]);
            } else if (data.jobs[i].departments[0].name == "Design") {
              design.push(data.jobs[i]);
            } else if (data.jobs[i].departments[0].name == "Customer Success") {
              customerSuccess.push(data.jobs[i]);
            } else if (data.jobs[i].departments[0].name == "Data Science") {
              dataScience.push(data.jobs[i]);
            } else if (data.jobs[i].departments[0].name == "Other") {
              otherPositions.push(data.jobs[i]);
            }
          }
        }
        if (engineering.length > 0) {
          jobsObject.engineering = engineering;
        }
        if (marketing.length > 0) {
          jobsObject.marketing = marketing;
        }
        if (design.length > 0) {
          jobsObject.design = design;
        }
        if (product.length > 0) {
          jobsObject.product = product;
        }
        if (people.length > 0) {
          jobsObject.people = people;
        }
        if (customerSuccess.length > 0) {
          jobsObject.customerSuccess = customerSuccess;
        }
        if (dataScience.length > 0) {
          jobsObject.dataScience = dataScience;
        }
        if (otherPositions.length > 0) {
          jobsObject.otherPositions = otherPositions;
        }
        setJobs(jobsObject);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <JobContainer>
      {jobs.engineering && (
        <JobWrapper>
          <JobType>Engineering</JobType>
          {jobs.engineering.map((item, index) => (
            <JobBox key={`engineering-${index}`} href={item.absolute_url} target="_blank">
              <JobTitle>{item.title}</JobTitle>
              <JobLocation>
                <Translate path="pages.jobs.openings.engineering.city" />
              </JobLocation>
            </JobBox>
          ))}
        </JobWrapper>
      )}

      {jobs.design && (
        <JobWrapper>
          <JobType>Design</JobType>
          {jobs.design.map((item, index) => (
            <JobBox key={`design-${index}`} href={item.absolute_url} target="_blank">
              <JobTitle>{item.title}</JobTitle>
              <JobLocation>
                <Translate path="pages.jobs.openings.city" />
              </JobLocation>
            </JobBox>
          ))}
        </JobWrapper>
      )}

      {jobs.marketing && (
        <JobWrapper>
          <JobType>Marketing and Communications</JobType>
          {jobs.marketing.map((item, index) => (
            <JobBox key={`marketing-${index}`} href={item.absolute_url} target="_blank">
              <JobTitle>{item.title}</JobTitle>
              <JobLocation>
                <Translate path="pages.jobs.openings.city" />
              </JobLocation>
            </JobBox>
          ))}
        </JobWrapper>
      )}

      {jobs.product && (
        <JobWrapper>
          <JobType>Product</JobType>
          {jobs.product.map((item, index) => (
            <JobBox key={`product-${index}`} href={item.absolute_url} target="_blank">
              <JobTitle>{item.title}</JobTitle>
              <JobLocation>
                <Translate path="pages.jobs.openings.city" />
              </JobLocation>
            </JobBox>
          ))}
        </JobWrapper>
      )}

      {jobs.people && (
        <JobWrapper>
          <JobType>People</JobType>
          {jobs.people.map((item, index) => (
            <JobBox key={`people-${index}`} href={item.absolute_url} target="_blank">
              <JobTitle>{item.title}</JobTitle>
              <JobLocation>
                <Translate path="pages.jobs.openings.city" />
              </JobLocation>
            </JobBox>
          ))}
        </JobWrapper>
      )}

      {jobs.customerSuccess && (
        <JobWrapper>
          <JobType>Customer Success</JobType>
          {jobs.customerSuccess.map((item, index) => (
            <JobBox key={`customer-success-${index}`} href={item.absolute_url} target="_blank">
              <JobTitle>{item.title}</JobTitle>
              <JobLocation>
                <Translate path="pages.jobs.openings.city" />
              </JobLocation>
            </JobBox>
          ))}
        </JobWrapper>
      )}

      {jobs.dataScience && (
        <JobWrapper>
          <JobType>Data Science</JobType>
          {jobs.dataScience.map((item, index) => (
            <JobBox key={`data-science-${index}`} href={item.absolute_url} target="_blank">
              <JobTitle>{item.title}</JobTitle>
              <JobLocation>
                <Translate path="pages.jobs.openings.city" />
              </JobLocation>
            </JobBox>
          ))}
        </JobWrapper>
      )}

      {jobs.otherPositions && (
        <JobWrapper>
          <JobType>Other</JobType>
          {jobs.otherPositions.map((item, index) => (
            <JobBox key={`other-positions-${index}`} href={item.absolute_url} target="_blank">
              <JobTitle>{item.title}</JobTitle>
              <JobLocation>
                <Translate path="pages.jobs.openings.city" />
              </JobLocation>
            </JobBox>
          ))}
        </JobWrapper>
      )}
    </JobContainer>
  );
}

export default CurrentOpeningsSection;
